const timezoneMap = {
    Alaska: 'US/ALASKA',
    Central: 'US/CENTRAL',
    Eastern: 'US/EASTERN',
    Hawaii: 'US/HAWAII',
    Mountain: 'US/MOUNTAIN',

    Pacific: 'US/PACIFIC',
    Samoa: 'Pacific/Samoa',
    'UTC+9': 'Pacific/Palau',
    'UTC+10': 'Pacific/Guam',
    'UTC+12': 'Pacific/Majuro',
};

/**
 * Given the timezone ID from props, get the corresponding timezone object
 * {
 *     id: US/ARIZONA
 *     display: Arizona
 * }
 *
 * @returns {{id: string, display: string}} Timezone object
 */
const getTimezoneById = (timezones, id) =>
    getTimezonesList(timezones)?.find(tz => tz.id === id) || {
        id,
        display: '',
    };

const getTimezonesList = (timezones, country = 'ALL') => {
    if (!timezones) {
        return [];
    }
    return country !== 'ALL'
        ? timezones?.filter(timezone => timezone.country === country)
        : timezones;
};
/**
 * Map timezone returned from verified address in SmartyStreets to a standard timezone the webapp can use
 *
 * Reference: https://smartystreets.com/docs/cloud/us-street-api
 * SmartyStreets returns the following timezones for verified U.S. addresses:
 *     Alaska, Atlantic, Central, Eastern, Hawaii, Mountain, None, Pacific, Samoa, UTC+9, UTC+10, UTC+11, UTC+12
 *
 * @param {string} smartyStreetsTimezone SmartyStreets timezone
 * @returns {string} Standardized tz database string for timezone
 */
const mapSmartyStreetsTimezone = (smartyStreetsTimezone, timezones) => {
    const mappedTimezoneId =
        timezoneMap[smartyStreetsTimezone] || smartyStreetsTimezone;

    const timezone = getTimezoneById(timezones, mappedTimezoneId);
    return timezone || getTimezoneById(timezones, timezoneMap.Mountain);
};

export { getTimezonesList, getTimezoneById, mapSmartyStreetsTimezone };
